export const getTourStatus = state => {
  return state.tourStatus;
};
export const getPanelsStatus = state => {
  return state.panelsStatus;
};